<template>
  <div>
    <div class="page_center">
      <div style="height:71px; width:100%"></div>
      <div class="banner-top-wrapper">
        <image-component :path="bannerPath"></image-component>
        <div class="banner-title"></div>
        <a
          class="download-banner"
          target="_blank"
          href="https://play.google.com/store/apps/details?id=com.SpringSoft.HAPPYTABLET&pcampaignid=web_share"
        >
          <img src="@/assets/source/images/happytablet/bt_google_play.png" />
        </a>
      </div>
      <section class="update-content-wrapper">
        <article class="article-padding">
          <p class="sub-index">특징 1</p>
          <p class="content">
            혼자서도 즐기는 <span class="deepOrange">1인용 모드</span>
          </p>
          <image-component path="happytablet/image1.png"></image-component>
          <div
            class="flex"
            style="margin-top: 50px; justify-content: space-between; flex-wrap: nowrap;"
          ></div>
          <p class="content">
            <span class="medium">
              개인이 편안한 환경에서 소프트웨어를 통해 뇌를 활성화할 수 있는
              기회를 제공합니다.</span
            >
          </p>
        </article>
        <article class="article-padding">
          <div class="sub-index">특징 2</div>
          <p class="content">
            인지력 향상 게임 <span class="deepOrange">12종</span>
          </p>
          <image-component path="happytablet/image2.png"></image-component>
          <p class="content">
            <span class="medium">
              기억력, 문제해결 능력, 논리력 등을 향상시킬 수 있는 다양한 게임이
              포함되어 있습니다.
            </span>
          </p>
        </article>
        <article class="article-padding">
          <div class="sub-index">특징 3</div>
          <p class="content">
            온라인에서 만나 대전하는 <span class="deepOrange">멀티게임</span>
          </p>
          <image-component path="happytablet/image3.png"></image-component>
          <p class="content">
            <span class="medium"
              >가족이나 친구들과 함께 즐길 수 있는 멀티플레이 게임 3종이
              제공됩니다.</span
            >
          </p>
        </article>
      </section>
      <section class="update-content-wrapper card-content">
        <article class="article-padding card">
          <div class="note">
            다인 인지 프로그램의 개발 경험을 바탕으로
            <span class="deepOrange">1인 인지프로그램</span>도 완벽하게
            만들었습니다.
          </div>
          <div class="sub-index">특징 4</div>
          <p class="content">시니어의 사용성을 고려한 인터페이스</p>
          <image-component path="happytablet/image4.png"></image-component>
          <p class="content">
            <span class="medium"
              >직관적이고 사용자 친화적인 인터페이스로, 어떤 연령층에서도 쉽게
              사용 가능합니다.</span
            >
          </p>
          <div class="sub-index" style="margin-top: 105px;">특징 5</div>
          <p class="content">다양한 게임 난이도</p>
          <image-component path="happytablet/image5.png"></image-component>
          <p class="content">
            <span class="medium"
              >사용자의 레벨에 맞춰 조절되어, 초보자부터 전문가까지 모든
              사용자에게 적합합니다.</span
            >
          </p>
        </article>
      </section>
      <section class="business-content">
        <div class="article-padding content info">
          <p class="title fontExtraBold">문의하기</p>
          <p class="sub">
            3.5 업데이트에 대한 자세한 문의는 해피테이블 카카오 채널로 채팅
            부탁드립니다.
          </p>
          <a
            class="kakao-link"
            href="http://pf.kakao.com/_xjYRxab"
            target="_blank"
          >
            <div class="kakao" style="display:flex">
              <div class="kakao-img-wrapper">
                <img
                  src="@/assets/source/images/m_ic_sns_kakao.svg"
                  alt="go to kakao"
                />
              </div>
              <p class="title">카카오 채널 문의</p>
            </div>
          </a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import imageComponent from "@/components/imageComponent.vue";
export default {
  components: {imageComponent},
  data() {
    return {
      isJpg: false,
      bannerPath: "happytablet/banner.png",
    };
  },
};
</script>
<style>
.deepOrange {
  color: #ff5230;
}
.orange {
  color: #ef7d52;
}
</style>
<style scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 60px 30px;
}
.flex > * {
  flex: 1 1 auto;
}

.banner-top-wrapper {
  position: relative;
}
.banner-top-wrapper >>> img {
  display: block;
}
.download-banner {
  position: absolute;
  bottom: 6.5%;
  left: 2.5%;
  width: 25%;
  & > img {
    width: 100%;
    max-width: fit-content;
  }
}

.banner-title {
  position: absolute;
  top: calc(100vw / 20);
  left: 50%;
  transform: translate(-50%, 0%);
  width: 100%;
}
.banner-title .sub {
  text-align: center;
  font: normal normal 500 36px/61px paybooc;
  letter-spacing: 0px;
  color: #737373;
  display: block;
  /* margin-bottom: 30px; */
  margin-bottom: calc(100vw / 64);
  font-size: calc(100vw / 53.33);
  line-height: calc(100vw / 31.47);
}
.banner-title .main {
  font: normal normal 800 80px/68px paybooc;
  letter-spacing: -4px;
  font-size: calc(100vw / 24);
  line-height: calc(100vw / 28.23);
}

.deepOrange {
  color: #ff5230;
}
.sub-index {
  display: inline-block;
  background-color: #ef7d52;
  border-radius: 33px;
  padding: 19px 33px;
  font: normal normal 800 24px/28px paybooc;
  color: #ffffff;
}
.update-content-wrapper {
  padding: 100px 0;
}
.update-content-wrapper .content {
  max-width: 650px;
  margin: 0 auto;
  font: normal normal bold 36px/60px paybooc;
  padding: 40px 0 60px;
  word-break: keep-all;
}
.update-content-wrapper .note {
  font: normal normal 500 45px/90px paybooc;
  padding: 65px 118px;
  margin-bottom: 105px;
  letter-spacing: -1.35px;
  word-break: keep-all;
  background: white 0% 0% no-repeat padding-box;
  border-radius: 33px;
}
.update-content-wrapper .note .deepOrange {
  line-height: inherit;
  font-weight: bold;
  border-bottom: 4px solid #ff5230;
  display: inline-block;
}

.update-content-wrapper >>> img {
  display: block;
}
.update-content-wrapper .content .medium {
  font: normal normal 500 30px/60px paybooc;
  font-size: smaller;
  word-break: keep-all;
}
.update-content-wrapper .content .small {
  font: normal normal 500 20px/60px paybooc;
  color: #929292;
}
.update-content-wrapper .icon {
  display: flex;
  justify-content: center;
  gap: 40px;
  align-items: center;
  padding-bottom: 40px;
}
.update-content-wrapper .old {
  display: inline-block;
  padding: 35px 96px;
  border-radius: 44px;
  box-shadow: 0px 0px 20px #d2d2d2;
  font: normal normal 800 28px/35px paybooc;
  word-break: keep-all;
  color: #7d7d7d;
}
.update-content-wrapper .new {
  display: inline-block;
  padding: 35px 96px;
  border-radius: 44px;
  box-shadow: 0px 0px 20px #ce3f09;
  word-break: keep-all;
  font: normal normal 800 28px/35px paybooc;
  color: #ff5230;
}
.card {
  padding: 3rem 0;
}
.card-content {
  background: #f6efe8 0% 0% no-repeat padding-box;
}
.card-content .info-content {
  padding: 21px 40px 6px;
  width: 45%;
  text-align: left;
}
.card-content .sub-content {
  font: normal normal 500 20px/39px paybooc;
  word-break: keep-all;
}
.card-content .title {
  font: normal normal 800 36px paybooc;
  padding: 20px 0 40px;
  word-break: keep-all;
}
.update-content-wrapper .info-block {
  display: flex;
  align-items: center;
  padding: 73px 0px 73px 40px;
  box-shadow: 0px 3px 6px #5e331529;
  margin-bottom: 3rem;
  background-color: #ffff;
}

.update-content-wrapper article {
  padding: 55px 0;
}
.article-padding {
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.icon-arrow {
  display: inline-block;
}
.icon-arrow >>> img {
  display: block;
}

/* 카카오톡 문의 */
.business-content {
  padding: 100px 0;
}
.business-content .sub {
  padding: 2.5rem 0;
  word-break: keep-all;
  font: normal normal 500 18px/38px paybooc;
  color: rgba(90, 90, 90, 1);
}
.business-content .title {
  font: normal normal 800 40px/60px paybooc;
}
.kakao-img-wrapper {
  width: 54px;
  height: 54px;
}
.kakao-img-wrapper img {
  display: block;
  width: 100%;
}
.kakao {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 524px;
  border: 2px solid #ef7d52;
  border-radius: 62px;
  margin: 0 auto;
  padding: 2rem 0;
}
.kakao .title {
  color: #d65422;
  font-size: 34px;
  margin-left: 2rem;
}
.kakao-link {
  text-decoration: none;
}

@media (max-width: 767px) {
  .banner-title {
    font-size: 1rem;
  }
  .banner-title .main {
    letter-spacing: 0;
  }
  .update-content-wrapper .content {
    font: normal normal 500 30px/54px paybooc;
    /* padding: 40px 0 60px; */
  }

  .update-content-wrapper .note {
    padding: 30px 50px;
    font: normal normal 500 30px/54px paybooc;
    /* padding: 40px 0 60px; */
  }

  .update-content-wrapper .old {
    padding: 30px 50px;
    font: normal normal 800 25px/30px paybooc;
  }

  .update-content-wrapper .new {
    padding: 30px 50px;
    font: normal normal 800 25px/30px paybooc;
  }

  .update-content-wrapper .info-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 73px 40px 73px 40px;
    box-shadow: 0px 3px 6px #5e331529;
    margin-bottom: 3rem;
    background-color: #ffff;
  }
  .card-content .info-content {
    padding: 21px 40px 6px;
    width: 100%;
    text-align: center;
  }
  .card-content .sub-content {
    text-align: center;
  }
  .update-content-wrapper article {
    padding: 35px 10% !important;
  }
  .update-content-wrapper {
    padding: 50px 0;
  }
  .kakao .title {
    font-size: 25px;
    margin-left: 1rem;
  }
}

@media (max-width: 550px) {
  .update-content-wrapper .content {
    font: normal normal 500 20px/35px paybooc;
    padding: 30px 0 40px;
  }

  .update-content-wrapper .note {
    padding: 30px 50px;
    font: normal normal 500 20px/35px paybooc;
    /* padding: 40px 0 60px; */
  }

  .update-content-wrapper .content .medium {
    font: normal normal 500 18px/25px paybooc;
  }

  .update-content-wrapper .content .small {
    font: normal normal 500 15px/25px paybooc;
    color: #929292;
  }
  .update-content-wrapper .icon {
    display: flex;
    justify-content: center;
    gap: 20px;
    align-items: center;
    padding-bottom: 40px;
  }
  .icon span {
    padding: 20px 20px !important;
    font: normal normal 800 18px/24px paybooc !important;
  }
  .update-content-wrapper .info-block {
    padding: 40px 20px;
  }
  .card-content .title {
    font: normal normal 800 30px paybooc;
    padding: 20px 0 30px;
  }
  .sub-index {
    padding: 15px 30px;
    font: normal normal 800 20px/28px paybooc;
  }
  .card-content .sub-content {
    font: normal normal 500 18px/35px paybooc;
    word-break: keep-all;
  }
  .business-content {
    padding: 50px 0;
  }
  .card .info-block:last-child {
    margin-bottom: 0;
  }
}
</style>
